export function getSizeStyles(size) {
  return require("./".concat(size, ".module.css"));
}